<template>
<div>
  <!-- <div class="dropdown">
    <button class="btn dropdown-toggle"
    				type="button"
    				id="dropdownMenuDatePickerButton"
    				data-toggle="dropdown"
    				aria-haspopup="true"
    				aria-expanded="false">
      {{ dateFormatted }}
    </button>
    <div class="dropdown-menu scrollable-menu" aria-labelledby="dropdownMenuDatePickerButton">
      <a v-for="(date, index) in dates"
         :key="index"
         @click="changeDateHandler(date)"
         class="dropdown-item">
        {{ date.label }}</a>
    </div>
  </div> -->
  <select class="form-control"
          name="select-date"
          tabindex="0"
          title="Select date"
          aria-label="Select date"
					v-model="date">
    <option v-for="(date, index) in dates"
            :value="date.value"
            :key="index">
    {{ date.label }}
    </option>
  </select>
</div>
</template>
<script>

export default {
  name: 'date-picker',
  props: ['format'],
  data () {
    return {
    }
  },
  watch: {
    when (val) {
      console.log("WHEN changed in datepicker")
      if (val === 'now') {
        this.date = this.currentDate.value
      }
    }
  },
  computed: {
    date: {
      get: function() {
        return this.$store.getters['tripPlanner/inputs'].when.date;
      },
      set: function( val ) {
        this.$store.commit('tripPlanner/SET_INPUT_DATE', val);
      }
    },
    when () {
      return this.$store.getters['tripPlanner/inputs'].when.type;
    },
  	formatSetting () {
  		return (this.format ? this.format : 'ddd, MMM Do')
  	},
    currentDate () {
      return {
      	value: moment().format('YYYY-MM-DD'),
      	formatted: moment().format(this.formatSetting)
      }
    },
    dateFormatted () {
  		return moment(this.date).format(this.formatSetting)
    },
    dates () {
      let result = []
      for (let i = 0, ilen = 30; i < ilen; i++) {
        let dt = moment().add(i, 'day')
        result.push({ value: dt.format('YYYY-MM-DD'), label: dt.format(this.formatSetting) })
      }
      return result
    }
  },
  methods: {
  	changeDateHandler (date) {
      this.date = date.value
  	}
  },
  mounted () {
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/DatePicker.vue